// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"67f410ca","57":"67f410ca","313":"67f410ca","480":"67f410ca","550":"67f410ca","623":"67f410ca","873":"67f410ca"}[chunkId] + ".chunk.css";
};